import {Component, Input} from "@angular/core";
import {NameFilter} from "../../../../../../infrastructure/occasions/filters/NameFilter";
import {MileageFilter} from "../../../../../../infrastructure/occasions/filters/MileageFilter";
import {PriceFilter} from "../../../../../../infrastructure/occasions/filters/PriceFilter";
import {BrandFilter} from "../../../../../../infrastructure/occasions/filters/BrandFilter";
import {GasolineFilter} from "../../../../../../infrastructure/occasions/filters/GasolineFilter";
import {GearboxFilter} from "../../../../../../infrastructure/occasions/filters/GearboxFilter";
import {OccasionsFilters} from "../../../../../../domain/occasions/filters/OccasionsFilters";
import {OccasionsSorting} from "../../../../../../domain/occasions/sorting/OccasionsSorting";
import {BrandFilterComponent} from "./filters/BrandFilter";
import {GearboxFilterComponent} from "./filters/GearboxFilter";
import {GasolineFilterComponent} from "./filters/GasolineFilter";
import {Sorting} from "../../../../../../domain/occasions/sorting/Sorting";
import {IDeviceInfo} from "../../../../../device/IDeviceInfo";

declare var $ :any;
@Component({
    selector: 'occasions-filter',
    styleUrls: ['./occasions-filter.scss'],
    templateUrl: './occasions-filter.html'
})
export class OccasionsFilterComponent {

    @Input() occasionsFilters:OccasionsFilters;
    @Input() occasionsSorting:OccasionsSorting;

    public nameFilter:NameFilter;
    public mileageFilter:MileageFilter;
    public priceFilter:PriceFilter;
    public brandFilter:BrandFilter;
    public gasolineFilter:GasolineFilter;
    public gearboxFilter:GearboxFilter;

    public brandFilterComponent:BrandFilterComponent;
    public gasolineFilterComponent:GasolineFilterComponent;
    public gearboxFilterComponent:GearboxFilterComponent;

    public deviceInfo:IDeviceInfo;

    constructor(deviceInfo:IDeviceInfo) {
        this.deviceInfo = deviceInfo;
        this.nameFilter = new NameFilter();
        this.mileageFilter = new MileageFilter();
        this.priceFilter = new PriceFilter();
        this.brandFilter = new BrandFilter();
        this.gasolineFilter = new GasolineFilter();
        this.gearboxFilter = new GearboxFilter();

        this.brandFilterComponent = new BrandFilterComponent(this.brandFilter);
        this.gasolineFilterComponent = new GasolineFilterComponent(this.gasolineFilter);
        this.gearboxFilterComponent = new GearboxFilterComponent(this.gearboxFilter);
    }

    ngOnInit(){
        this.AddFilters();
    }

    private AddFilters(){
        this.occasionsFilters.AddFilter(this.nameFilter);
        this.occasionsFilters.AddFilter(this.mileageFilter);
        this.occasionsFilters.AddFilter(this.priceFilter);
        this.occasionsFilters.AddFilter(this.brandFilter);
        this.occasionsFilters.AddFilter(this.gasolineFilter);
        this.occasionsFilters.AddFilter(this.gearboxFilter);
    }

    public updateFilters(){
        this.UpdateNameFilter();
        this.UpdateRangeFilter();
        this.UpdateMileageFilter();
        this.occasionsFilters.Update();
    }

    public sortingPriceClicked(){
        let newSorting = this.occasionsSorting.PriceSorting() + 1;
        if(newSorting > Sorting.Descending){
            newSorting = Sorting.None;
        }
        this.occasionsSorting.SetPricingSorting(newSorting);
        this.UpdateFiltersBackground();
    }

    public sortingMileageClicked(){
        let newSorting = this.occasionsSorting.MileageSorting() + 1;
        if(newSorting > Sorting.Descending){
            newSorting = Sorting.None;
        }
        this.occasionsSorting.SetMileageSorting(newSorting);
        this.UpdateFiltersBackground();
    }

    private UpdateNameFilter(){
        let name = $('#name').val();
        this.nameFilter.SetValue(name);
    }

    private UpdateRangeFilter(){
        let priceMin = +$('#price-min').val();
        let priceMax = +$('#price-max').val();

        if(priceMax > 0 && priceMax < priceMin){
            this.HighlightPriceError();
            return;
        }
        this.RemoveHighlightPriceError();

        this.priceFilter.SetMinValue(priceMin);
        if(priceMax > 0){
            this.priceFilter.SetMaxValue(priceMax);
        }else{
            this.priceFilter.SetMaxValue(Number.MAX_VALUE);
        }
    }

    private UpdateFiltersBackground(){
        this.UpdatePriceFilterBackground();
        this.UpdateMileageFilterBackground();
    }

    private UpdatePriceFilterBackground(){
        if(this.occasionsSorting.PriceSorting() == Sorting.None){
            $('#price-soring-button').removeClass('flat');
        }else{
            $('#price-soring-button').addClass('flat');
        }
    }

    private UpdateMileageFilterBackground(){
        if(this.occasionsSorting.MileageSorting() == Sorting.None){
            $('#mileage-soring-button').removeClass('flat');
        }else{
            $('#mileage-soring-button').addClass('flat');
        }
    }

    private UpdateMileageFilter(){
        let mileageMin = +$('#mileage-min').val();
        let mileageMax = +$('#mileage-max').val();

        if(mileageMax > 0 && mileageMax < mileageMin){
            this.HighlightMileageError();
            return;
        }
        this.RemoveHighlightMileageError();

        this.mileageFilter.SetMinValue(mileageMin);
        if(mileageMax > 0){
            this.mileageFilter.SetMaxValue(mileageMax);
        }else{
            this.mileageFilter.SetMaxValue(Number.MAX_VALUE);
        }
    }

    private HighlightPriceError(){
        $('#price-div-min').addClass('error');
        $('#price-div-max').addClass('error');
    }

    private HighlightMileageError(){
        $('#mileage-div-min').addClass('error');
        $('#mileage-div-max').addClass('error');
    }

    private RemoveHighlightPriceError(){
        $('#price-div-min').removeClass('error');
        $('#price-div-max').removeClass('error');
    }

    private RemoveHighlightMileageError(){
        $('#mileage-div-min').removeClass('error');
        $('#mileage-div-max').removeClass('error');
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/occasions/content/occasions-filter/occasions-filter.ts